import {
  BreakpointsEnum,
  isBreakpointUp,
  useBreakpoint,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';

import OcrmRewardListItem, {
  OcrmRewardSize,
} from 'components/OcrmRewardList/OcrmRewardListItem/OcrmRewardListItem';
import {useGetTextFromApi} from 'hooks/useGetTextFromApi';
import {usePropertyList} from 'hooks/usePropertyList';
import {OCRMReward, RewardState} from 'models/Offer';

interface OcrmRewardProps {
  reward: OCRMReward;
  onSelected: () => void;
  selected: boolean;
  isDownloadVisible?: boolean;
  setIsDownloadVisible?: (isVisible: boolean) => void;
  onDownloadPress?: () => void;
}

/**
 * Container component that provides connected store/api calls.
 */
const OcrmReward = (props: OcrmRewardProps) => {
  const {
    reward,
    selected,
    onSelected,
    isDownloadVisible,
    setIsDownloadVisible,
    onDownloadPress,
  } = props;
  const {links} = reward;
  const breakpointSize = useBreakpoint() ?? 4;
  const properties = usePropertyList(reward.propertyList);
  const size = isBreakpointUp(breakpointSize, BreakpointsEnum.XL)
    ? OcrmRewardSize.Desktop
    : OcrmRewardSize.Mobile;

  const termsUrl = links.link.find(link => link.rel === 'terms')?.href;
  const {text, error} = useGetTextFromApi(termsUrl);

  const msgUrl = links.link.find(l => l.rel === 'postAcceptMessage')?.href;
  const {text: acceptMessage, error: acceptError} = useGetTextFromApi(msgUrl);
  const isAccepted = reward.state === RewardState.SUCCESS;

  return (
    <OcrmRewardListItem
      size={size}
      properties={properties.offerProperties.map(p => p.propertyName)}
      imageUrl={links.link.find(link => link.rel === 'image')?.href}
      terms={text}
      termsError={error}
      onSelected={onSelected}
      selected={selected}
      acceptMessage={acceptError ? undefined : acceptMessage}
      isAccepted={isAccepted}
      isDownloadVisible={isDownloadVisible}
      setIsDownloadVisible={setIsDownloadVisible}
      onDownloadPress={onDownloadPress}
      {...reward}
    />
  );
};

export default OcrmReward;
